import { useReducer, useEffect, useCallback } from 'react';
import { openMenu, closeMenu } from 'react-aria-menubutton';
var Actions;
(function (Actions) {
    Actions[Actions["ADD"] = 0] = "ADD";
})(Actions || (Actions = {}));
const reducer = (state, action) => {
    switch (action.type) {
        case Actions.ADD:
            return {
                listeners: [...state.listeners, action.payload],
            };
        // May want to add ability to remove listeners in a future release.
        // We would want to add a uuid to each listener to identify for removal.
        default:
            return state;
    }
};
/**
 * @deprecated
 * DropdownMenuDEPRECATED and useDropdownContextDEPRECATED have been deprecated
 * and _will be removed_ in the v25 release of metronome-ui.
 * Please use the DropdownMenu component instead.
 */
export const useDropdownContextDEPRECATED = () => {
    const [state, dispatch] = useReducer(reducer, { listeners: [] });
    const open = () => {
        state.listeners.forEach((listener, index) => {
            listener('open_menu');
        });
    };
    const close = () => {
        state.listeners.forEach(listener => {
            listener('close_menu');
        });
    };
    const registerListener = (listener) => {
        dispatch({ type: Actions.ADD, payload: listener });
    };
    return { openMenu: open, closeMenu: close, registerListener };
};
export const useInternalDropdownContext = ({ context, wrapperId, }) => {
    const contextListener = useCallback((option) => {
        if (option === 'open_menu') {
            openMenu(wrapperId || '', { focusMenu: true });
        }
        if (option === 'close_menu') {
            closeMenu(wrapperId || '', { focusButton: true });
        }
    }, [wrapperId]);
    useEffect(() => {
        context === null || context === void 0 ? void 0 : context.registerListener(contextListener);
    }, []);
};
//# sourceMappingURL=use-dropdown-context.js.map